import * as firebase from 'firebase';

/**
 * Basic interface to providers that will interact Firebase Firestore.
 */
export interface BasicFirestore {

  getCollection(name: string): Promise<firebase.firestore.QuerySnapshot>;

  watchCollection(name: string): firebase.firestore.CollectionReference;

  addToCollection(name: string, item: any): Promise<firebase.firestore.DocumentReference>;

  getDocument(name: string): Promise<firebase.firestore.DocumentSnapshot>;

  watchDocument(name: string): firebase.firestore.DocumentReference;

  addDocument(name: string, item: any): Promise<void>;

  updateDocument(name: string, item: any): Promise<void>;

  removeDocument(name: string): Promise<void>;

  unsubscribe(subscriptions: object): any;

}